"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockedContentButton = void 0;
exports.lockedContentButton = {
    loadingButton: {
        width: 175,
    },
};
